<template>
  <div v-if="isLoading">
    <Preloader/>
  </div>
  <div class="row" v-else>
    <div class="col-md-3 col-md-offset-2">
      <section class="list">
        <header>در انتظار</header>
        <draggable class="drag-area" :list="inQueueWorklist" :options="{animation:200, group:'status'}"
                   :element="'article'" @add="onAdd($event, `inqueue`)" @change="update">
          <article class="card" v-for="(task, index) in inQueueWorklist" :key="task.id" :data-id="task.id">
            <header>
              <div>
                <span class="d-block">{{ "نام کالا :"+ task.productName}}</span>
                <span> تعداد :  ({{task.workCount}}) با {{task.priorityName}}</span>
                <small class="d-block">{{ "کد برنامه تولید :"+ task.productOrderCode}}</small>
                <small> {{ "کد سفارش :"+ task.orderCode}}</small>
                <small class="d-block"> {{ "دستورات کار :"+ task.workDescription}}</small>
                <small class="d-block"> {{ "توضیحات سفارش :"+ task.orderDetailDescription}}</small>
              </div>
            </header>
          </article>
          <!--<div-->
          <!--class="list-group-item"-->
          <!--v-for="(element, index) in inQueueWorklist"-->
          <!--:key="element.id"-->
          <!--&gt;-->
          <!--{{ element.orderCode+" "+ element.workCode + " " + element.productName}}-->
          <!--</div>-->
        </draggable>
      </section>
    </div>
    <!--<div class="col-md-3">-->
    <!--&lt;!&ndash;<section class="list">&ndash;&gt;-->
    <!--&lt;!&ndash;<header>درحال انجام</header>&ndash;&gt;-->
    <!--&lt;!&ndash;<draggable class="drag-area" :list="doingWorklist" :options="{animation:200, group:'status'}"&ndash;&gt;-->
    <!--&lt;!&ndash;:element="'article'" @add="onAdd($event, `doing`)" @change="update">&ndash;&gt;-->
    <!--&lt;!&ndash;<article class="card" v-for="(task, index) in doingWorklist" :key="task.id" :data-id="task.id">&ndash;&gt;-->
    <!--&lt;!&ndash;<header>&ndash;&gt;-->
    <!--&lt;!&ndash;<div>&ndash;&gt;-->
    <!--&lt;!&ndash;<span class="d-block">{{ "نام کالا :"+ task.productName}}</span>&ndash;&gt;-->
    <!--&lt;!&ndash;<span> تعداد :  ({{task.workCount}}) با {{task.priorityName}}</span>&ndash;&gt;-->
    <!--&lt;!&ndash;<small class="d-block">{{ "کد برنامه تولید :"+ task.productOrderCode}}</small>&ndash;&gt;-->
    <!--&lt;!&ndash;<small> {{ "کد سفارش :"+ task.orderCode}}</small>&ndash;&gt;-->
    <!--&lt;!&ndash;<small class="d-block"> {{ "دستورات کار :"+ task.workDescription}}</small>&ndash;&gt;-->
    <!--&lt;!&ndash;<small class="d-block"> {{ "توضیحات سفارش :"+ task.orderDetailDescription}}</small>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</header>&ndash;&gt;-->
    <!--&lt;!&ndash;</article>&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;<div&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;class="list-group-item"&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;v-for="(element, index) in doingWorklist"&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;:key="element.id"&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;&gt;&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;{{ element.orderCode+" "+ element.workCode + " " + element.productName}}&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;</draggable>&ndash;&gt;-->
    <!--&lt;!&ndash;</section>&ndash;&gt;-->
    <!--</div>-->
    <div class="col-md-3">
      <section class="list">
        <!--<header>انجام شده</header>-->
        <!--<draggable class="drag-area" :list="doneWorklist" :options="{animation:200, group:'status'}"-->
        <!--:element="'article'" @add="onAdd($event, `done`)" @change="update">-->
        <!--<article class="card" v-for="(task, index) in doneWorklist" :key="task.id" :data-id="task.id">-->
        <!--<header>-->
        <!--<div>-->
        <!--<span class="d-block">{{ "نام کالا :"+ task.productName}}</span>-->
        <!--<span> تعداد :  ({{task.workCount}}) با {{task.priorityName}}</span>-->
        <!--<small class="d-block">{{ "کد برنامه تولید :"+ task.productOrderCode}}</small>-->
        <!--<small> {{ "کد سفارش :"+ task.orderCode}}</small>-->
        <!--<small class="d-block"> {{ "دستورات کار :"+ task.workDescription}}</small>-->
        <!--<small class="d-block"> {{ "توضیحات سفارش :"+ task.orderDetailDescription}}</small>-->
        <!--</div>-->
        <!--</header>-->
        <!--</article>-->
        <!--</draggable>-->
        <header>ثبت ضایعات</header>
        <draggable class="drag-area" :list="damagedList" :options="{animation:200, group:'status'}"
                   :element="'article'" @add="onAdd($event, `done`)" @change="update">
          <!--<article class="card">-->
          <!--<header>-->
          <!--&lt;!&ndash;<div>&ndash;&gt;-->
          <!--&lt;!&ndash;<span class="d-block" @click="addDamage">ثبت ضایعاتی</span>&ndash;&gt;-->

          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--</header>-->
          <!--</article>-->
        </draggable>
      </section>
    </div>

    <div class="col-md-3">
      <section class="list">
        <header>متوقف شده</header>
        <draggable class="drag-area" :list="problemWorklist" :options="{animation:200, group:'status'}"
                   :element="'article'" @add="onAdd($event , `problem`)" @change="update">
          <article class="card" v-for="(task, index) in problemWorklist" :key="task.id" :data-id="task.id">
            <header>
              <div>
                <span class="d-block">{{ "نام کالا :"+ task.productName}}</span>
                <span> تعداد :  ({{task.workCount}}) با {{task.priorityName}}</span>
                <small class="d-block">{{ "کد برنامه تولید :"+ task.productOrderCode}}</small>
                <small> {{ "کد سفارش :"+ task.orderCode}}</small>
                <small class="d-block"> {{ "دستورات کار :"+ task.workDescription}}</small>
                <small class="d-block"> {{ "توضیحات سفارش :"+ task.orderDetailDescription}}</small>
              </div>
            </header>
          </article>
          <!--<div-->
          <!--class="list-group-item"-->
          <!--v-for="(element, index) in problemWorklist"-->
          <!--:key="element.id"-->
          <!--&gt;-->
          <!--{{ element.orderCode+" "+ element.workCode + " " + element.productName}}-->
          <!--</div>-->
        </draggable>
      </section>
    </div>

    <div class="col-md-3">
      <section class="list">
        <header>تایید نهایی</header>
        <draggable class="drag-area" :list="tasksNotCompletedNew" :options="{animation:200, group:'status'}"
                   :element="'article'" @add="onAdd($event , `confirm`)" @change="update">
          <article class="card" v-for="(task, index) in tasksNotCompletedNew" :key="task.id" :data-id="task.id">
            <header>
              <div>
                <span class="d-block">{{ "نام کالا :"+ task.productName}}</span>
                <span> تعداد :  ({{task.workCount}}) با {{task.priorityName}}</span>
                <small class="d-block">{{ "کد برنامه تولید :"+ task.productOrderCode}}</small>
                <small> {{ "کد سفارش :"+ task.orderCode}}</small>
                <small class="d-block"> {{ "دستورات کار :"+ task.workDescription}}</small>
                <small class="d-block"> {{ "توضیحات سفارش :"+ task.orderDetailDescription}}</small>
              </div>
            </header>
          </article>
          <!--<div-->
          <!--class="list-group-item"-->
          <!--v-for="(element, index) in problemWorklist"-->
          <!--:key="element.id"-->
          <!--&gt;-->
          <!--{{ element.orderCode+" "+ element.workCode + " " + element.productName}}-->
          <!--</div>-->
        </draggable>
      </section>
    </div>
    <!--</div>-->

    <!------------------------------------------------------>
    <!------------------------------------------------------>
    <b-modal
      id="setWorkCount"
      ref="setWorkCount"
      size="lg"
      title="گزارش تعداد کار"
      ok-title="تایید"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkWorkCount"
    >

      <!--<div class="row mb-2">-->
      <!--<label class="p-2">لطفا به سوال زیر با دقت پاسخ دهید :</label>-->
      <!--</div>-->
      <!--<div class="row mb-2">-->
      <!--<div class="col-8">-->
      <!--<label class="p-2">چه تعداد از {{this.mainWorkCount}} عدد کار را میخواهید تغییر وضعیت دهید؟ </label>-->
      <!--<input type="number" v-model="answerWorkCount"/>-->
      <!--</div>-->

      <!--</div>-->

      <div class="row mb-2">
        <label class="p-2">لطفا به سوال زیر با دقت پاسخ دهید :</label>
      </div>
      <div class="row mb-2">

        <div class="input-group col-8  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>چه تعداد از {{this.mainWorkCount}} عدد کار را میخواهید تغییر وضعیت دهید؟ </span>
            </div>
          </div>
          <input type="number" class="form-control" v-model="answerWorkCount">
        </div>

        <div class="input-group col-4 mb-2">
          <div class="input-group-prepend custom w-100">
            <div class="input-group-text">
              <span>اپراتور</span>
            </div>
            <vs-select
              ref="selectedProductPattern"
              :isHeader="true"
              :data="users"
              :selectedVal="selectedUser.name"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="userSelect"
            ></vs-select>
          </div>
        </div>

        <div class="input-group col-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>شروع کار</span>
            </div>
          </div>
          <input
            v-show=false
            readonly="readonly"
            v-model="startDate"
            type="text"
            class="form-control"
          >
          <date-picker
            v-show=true
            type="datetime"
            :auto-submit="true"
            format="jYYYY-jMM-jDD HH:mm"
            display-format="jYYYY-jMM-jDD HH:mm"
            initial-value="2024-01-01 07:00"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="startDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <div class="input-group col-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>پایان کار</span>
            </div>
          </div>
          <input
            v-show=false
            readonly="readonly"
            v-model="endDate"
            type="text"
            class="form-control"
          >
          <date-picker
            v-show=true
            type="datetime"

            :auto-submit="true"
            format="YYYY-MM-DD HH:mm"
            display-format="jYYYY-jMM-jDD HH:mm"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="endDate"
                class="form-control date-input"
                @click="toggleEndDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <div class="input-group col-12  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <input type="text" class="form-control" v-model="workReport.description">
        </div>

      </div>
    </b-modal>

    <!------------------------------------------------------>
    <b-modal
      id="setProblemState"
      ref="setProblemState"
      size="lg"
      title="گزارش توقف کار"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleProblemOk"
    >

      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب نوع وقفه</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="productTypes"
                :selectedVal="productTypes.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="problemTypeSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب وقفه</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="workProblem"
                :selectedVal="workProblem.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="workProblemSelect"
              ></vs-select>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات وقفه</span>
            </div>
          </div>
          <!--<input id="problemdescription" type="text" class="form-control" v-model="workProblem.description" readonly="readonly" >-->
          <label class="form-control">{{ workProblemDescription }}</label>
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>


    </b-modal>
    <!------------------------------------------------------>
    <b-modal
      id="setDamageState"
      ref="setDamageState"
      size="lg"
      title="ثبت ضایعات"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="damageOk"
    >

      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom w-100">
              <div class="input-group-text">
                <span>انتخاب علت ضایعات</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="damageTypes"
                :selectedVal="damageTypes.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="damageTypeSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom w-100">
              <div class="input-group-text">
                <span>انتخاب کالا</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="products"
                :selectedVal="products.materialName"
                :header="{label:'materialName'}"
                :mode="'edit'"
                @dataChanged="productSelect"
              ></vs-select>
            </div>
          </div>
        </div>

      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>تعداد</span>
            </div>
          </div>
          <input type="number" class="form-control" v-model="damageProduct.value">
          <!--<label class="form-control">{{ damageProduct.value }}</label>-->
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
        <div class="input-group col-sm-6  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <input type="text" class="form-control" v-model=" damageProduct.description">
          <!--<label class="form-control">{{ damageProduct.description }}</label>-->
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>


    </b-modal>
    <!------------------------------------------------------>
    <b-modal
      id="setQuestionState"
      ref="setQuestionState"
      size="lg"
      title="سوالات تایید نهایی کار"
      :ok-title="btnName"
      cancel-title="بستن"
      @show="showModal"
      @hidden="nextQuestion"
      @ok="handleQuestion"
    >
      <div class="row mb-2">
        <label class="p-2">لطفا به سوال زیر با دقت پاسخ دهید :</label>
      </div>
      <div class="row mb-2">
        <div class="col-8" v-if="questionIsProduct">
          <label class="p-2"> چه مقدار از کالای {{ questionProductName }} مصرف شد؟ </label>
          <input type="number" v-model="answer"/>
        </div>
        <div class="col-8" v-else>
          <label class="p-2">{{ questionTitle }}</label>
          <input v-if="questionType === 0" type="text" v-model="answer"/>
          <input v-if="questionType === 1" type="number" v-model="answer"/>
          <input v-if="questionType === 2" type="checkbox" v-model="answer"/>
          <input v-if="questionType === 3" type="time" v-model="answer"/>
        </div>
      </div>


    </b-modal>


  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import axios from 'axios';
  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService";
  import Utils from "../../_framework/utils/Utils";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";

  export default {
    components: {
      draggable,
      VsSelect,
      datePicker: DatePicker,
    },
    props: ['tasksCompleted', 'tasksNotCompleted'],
    data() {
      return {
        workReport: {
          id: [],
          items: [],
          start: "",
          end: "",
          userId: 0,
          description: "",
          problemId: null
        },

        isLoading: false,
        allWorks: [],
        productTypes: [],
        productTypesId: 0,
        workProblem: [],
        workProblemId: 0,
        workProblemDescription: "",
        workId: 0,
        inQueueWorklist: [],
        doingWorklist: [],
        doneWorklist: [],
        damagedList: [],
        problemWorklist: [],
        tasksNotCompletedNew: this.tasksNotCompleted,
        tasksCompletedNew: this.tasksCompleted,
        questionlist: [],
        answerList: [],
        questionTitle: "",
        questionType: 0,
        questionFormId: 0,
        questionIndex: 0,
        questionProductId: 0,
        questionProductName: "",
        questionIsProduct: false,
        answer: "",
        btnName: "ذخیره",
        answerWorkCount: 0,
        mainWorkCount: 0,
        modalStatus: "",
        allWorkIndex: 0,
        damageTypes: [],
        damageType: {
          name: "",
        },
        products: [],
        selectedProduct: {
          materialName: "",
        },
        damageValue: 0,
        damageDescription: "",
        damageProduct: {
          damageTypeId: 0,
          companyId: 0,
          productId: 0,
          workId: 0,
          value: 0.0,
          description: "",
          isMain: false,
        },

        startDate: "",
        endDate: "",
        users: [],
        selectedUser: {name: ""},


      }
    },
    mounted() {
      this.getAllWorks();
      this.getdamageType();
      this.getUsers();
    }
    ,
    methods: {
      getAllWorks() {
        this.allWorks = [];
        this.inQueueWorklist = [];
        this.problemWorklist = [];
        this.doingWorklist = [];
        this.doneWorklist = [];
        this.isLoading = true;
        new BaseService('Works', '/WorksOfCompany').getList().then((response) => {
          // Utils.handleErrorWithNotification("کار با موفقیت تعریف شد", this.$noty);

          this.allWorks = response.data;
          for (var i = 0; i < this.allWorks.length; i++) {
            switch (this.allWorks[i].workPriority) {
              case 0:
                this.allWorks[i]['priorityName'] = "اولویت کم";
                break;
              case 1:
                this.allWorks[i]['priorityName'] = "اولویت متوسط";
                break;
              case 2:
                this.allWorks[i]['priorityName'] = "اولویت زیاد";
                break;
            }
          }
          this.setStates(this.allWorks);
          // console.log(this.allWorks);
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      resetModal() {
      },
      setStates(allworks) {
        // console.log(allworks);
        // console.log(allworks.length );

        for (let i = 0; i < allworks.length; i++) {
          switch (allworks[i].status) {
            case 0:
              this.inQueueWorklist.push(allworks[i]);
              break;
            case 1:
              this.problemWorklist.push(allworks[i]);
              break;
            case 2:
              this.doingWorklist.push(allworks[i]);
              break;
            case 3:
              this.doneWorklist.push(allworks[i]);
              break;
          }
        }
        this.isLoading = false;
      },
      problemTypeSelect(prop, data) {
        this.productTypesId = data.id;
        new BaseService('WorkProblems', '/GetProblemsByTypeId/' + this.productTypesId).getList().then((response) => {
          // Utils.handleErrorWithNotification("کار با موفقیت تعریف شد", this.$noty);
          // this.$noty.success("وضعیت با موفقیت تغییر کرد");

          this.workProblem = response.data;
          if (this.workProblem <= 0) {
            Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          }
        }).catch((error) => {
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      workProblemSelect(prop, data) {
        this.workProblemId = data.id;
        this.workProblemDescription = data.description;

        // document.id(problemdescription).text = data.description;
        // this.$set(this.problemdescription);
        // #problemdescription.text = data.description;
        // this.parameters.priority = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      handleOkWorkCount() {
        // console.log(this.workId);
        // console.log(this.allWorks[this.allWorkIndex]);
        // if (this.answerWorkCount > this.allWorks[this.allWorkIndex].workCount) {
        //   Utils.handleErrorWithNotification("تعداد کار نمیتواند از تعداد اصلی بیشتر یاشد. لطفا با دقت پاسخ دهید", this.$noty);
        //   this.getAllWorks();
        // } else
        if (this.answerWorkCount < 1) {
          Utils.handleErrorWithNotification("تعداد کار نمیتواند کمتر از یک عدد باشد. لطفا با دقت پاسخ دهید", this.$noty);
          this.getAllWorks();
        } else if (this.workReport.userId === 0) {
          Utils.handleErrorWithNotification("لطفا اپراتور را انتخاب کنید", this.$noty);
          this.getAllWorks();
        } else if (this.workReport.start === "") {
          Utils.handleErrorWithNotification("لطفا تاریخ و ساعت شروع کار را انتخاب کنید", this.$noty);
          this.getAllWorks();
        } else if (this.workReport.end === "") {
          Utils.handleErrorWithNotification("لطفا تاریخ و ساعت پایان کار را انتخاب کنید", this.$noty);
          this.getAllWorks();
        } else {
          this.changeWorkStatus();
        }


      },
      handleProblemOk() {
        let paramOk = true;
        if (this.workProblemId <= 0) {
          Utils.handleErrorWithNotification("لطفا نوع وقفه را انتخاب کنید", this.$noty);
          paramOk = false;
        }
        if (paramOk) {
          var workIdess = [];
          if (this.answerWorkCount === -1) {
            workIdess.push(this.workId)
            workIdess.push(1)
          } else {
            // for (var i = 0; i < this.answerWorkCount; i++) {
            //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
            // }
            workIdess.push(this.workId)
            workIdess.push(this.answerWorkCount)
          }
          let updateWork = {
            id: workIdess,
            problemId: this.workProblemId,
          };
          this.workReport.id = workIdess;
          // this.workReport.items = this.answerList;
          this.workReport.problemId = this.workProblemId;
          new BaseService('Works', '/ProblemWorkState').update(this.workReport).then((response) => {
            this.$noty.success("وقفه با موفقیت ثبت شد");
            this.getAllWorks();
            // console.log(response.data)
          }).catch((error) => {
            console.log(error)
          });
        }


        // Prevent modal from closing
        // bvModalEvt.preventDefault();
        // // Trigger submit handler
        // this.handleSubmit();
        // if (this.editProblemTypeFlag === false) {
        //   this.createProblemType(this.name)
        // } else {
        //   this.updateProblemType(this.problemType);
        //   this.editProblemTypeFlag = false;
        // }
      },
      nextQuestion() {
        if (this.questionlist.length <= this.questionIndex) {
          this.questionIndex = 0;
          this.questionlist = null;
        } else {
          this.$refs['setQuestionState'].show();
        }
      },
      handleQuestion() {
        // this.makeAnswer();
        // this.$refs['setQuestionState'].hide();
        if (this.answer === "") {
          Utils.handleErrorWithNotification("لطفا با دقت به سوال پاسخ دهید", this.$noty);
        } else {

          const items = {
            productId: this.questionProductId,
            confirmFormId: this.questionFormId,
            answer: this.answer,
          };
          this.answerList.push(items);
          this.questionIndex++;
          // console.log(this.answerList);
          // console.log(this.questionlist.length);
          // console.log(this.questionIndex);
          if (this.questionlist.length <= this.questionIndex) {
            var workIdess = [];
            if (this.answerWorkCount === -1) {
              workIdess.push(this.workId)
            } else {
              for (var i = 0; i < this.answerWorkCount; i++) {
                workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
              }
            }
            let answerModel = {
              id: workIdess,
              items: this.answerList
            };
            this.workId = 0;
            this.answerList = [];
            new BaseService('Works', '/ConfirmWorkState_New').update(answerModel).then((response) => {
              this.$noty.success("وضعیت با موفقیت تغییر کرد");
              this.getAllWorks();
              // console.log(response.data);
            }).catch((error) => {
              console.log(error)
              this.questionIndex++;
              // this.makeQuestion();
              this.getAllWorks();
            });
          } else {
            this.makeQuestion();
          }
        }
      },
      noQuestion() {

        var workIdess = [];
        if (this.answerWorkCount === -1) {
          workIdess.push(this.workId)
          workIdess.push(1)
        } else {
          // for (var i = 0; i < this.answerWorkCount; i++) {
          //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
          // }
          workIdess.push(this.workId);
          workIdess.push(this.answerWorkCount);
        }
        console.log(workIdess)
        console.log(workIdess[1])
        for (const qs of this.questionlist) {


          const items = {
            productId: qs.productId,
            confirmFormId: qs.confirmFormId,
            answer: qs.percentage * workIdess[1],
          };
          this.answerList.push(items);
          this.questionIndex++;
        }

        let answerModel = {
          id: workIdess,
          items: this.answerList
        };
        console.log(answerModel);
        this.workReport.id = workIdess;
        this.workReport.items = this.answerList;
        this.workId = 0;
        this.answerList = [];
        this.isLoading = true;
        new BaseService('Works', '/ConfirmWorkState_New').update(this.workReport).then((response) => {
          this.$noty.success("وضعیت با موفقیت تغییر کرد");

          this.getAllWorks();
          // console.log(response.data);
        }).catch((error) => {
          console.log(error)
          this.questionIndex++;
          // this.makeQuestion();
          this.getAllWorks();
        });

      },
      showModal() {
        // console.log("showe");
      },
      onAdd(event, status) {
        this.modalStatus = status;
        this.workId = event.item.dataset.id;
        for (var i = 0; i < this.allWorks.length; i++) {
          if (this.allWorks[i].id === parseInt(this.workId)) {
            if (status === "done") {
              this.addDamage(this.allWorks[i]);
            } else {
              // if (this.allWorks[i].workIdes.length > 1) {
              if (this.allWorks[i].workCount > 1) {
                this.mainWorkCount = this.allWorks[i].workCount;
                this.allWorkIndex = i;
                this.answerWorkCount = 0;
                this.$refs['setWorkCount'].show();
              } else {
                this.answerWorkCount = -1;
                this.changeWorkStatus();
              }
            }
          }
        }
      },
      changeWorkStatus() {
        var workIdess = [];
        if (this.answerWorkCount === -1) {
          workIdess.push(this.workId)
          workIdess.push(1)
        } else {
          // for (var i = 0; i < this.answerWorkCount; i++) {
          //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
          // }
          workIdess.push(this.workId);
          workIdess.push(this.answerWorkCount);
        }
        let updateWork = {
          id: workIdess,
        };
        // console.log(updateWork);
        // let id = event.item.dataset.id;
        if (this.modalStatus === "inqueue") {
          new BaseService('Works', '/InQueueWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }
        if (this.modalStatus === "doing") {
          new BaseService('Works', '/DoingWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }
        if (this.modalStatus === "done") {
          new BaseService('Works', '/DoneWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }

        if (this.modalStatus === "problem") {
          // this.setProblemState;
          this.$refs['setProblemState'].show();
          new BaseService('WorkProblems', '/GetProblemTypes').getList().then((response) => {
            // Utils.handleErrorWithNotification("کار با موفقیت تعریف شد", this.$noty);
            // this.$noty.success("وضعیت با موفقیت تغییر کرد");

            this.productTypes = response.data;
            if (this.productTypes <= 0) {
              Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
              this.getAllWorks();
            }
          }).catch((error) => {
            Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
            console.log(error)
            this.getAllWorks();
          });
        }

        if (this.modalStatus === "confirm") {
          this.questionIndex = 0;
          new BaseService('Works', '/GetConfirmForm/' + this.workId).getList().then((response) => {
            // this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.questionlist = response.data;
            if (this.questionlist.length > 0) {
              // this.makeQuestion();
              // this.$refs['setQuestionState'].show();
              this.noQuestion();
            }
            // console.log(response.data);
          }).catch((error) => {
            console.log(error)
          });

        }

      },
      makeQuestion() {
        if (this.questionlist.length <= this.questionIndex) {
          this.questionIndex = 0;
          this.questionlist = null;
        } else {
          this.questionTitle = this.questionlist[this.questionIndex].title;
          this.questionType = this.questionlist[this.questionIndex].answerType;
          this.questionFormId = this.questionlist[this.questionIndex].confirmFormId;
          this.questionProductId = this.questionlist[this.questionIndex].productId;
          this.answer = "";
          if (this.questionlist[this.questionIndex].confirmFormId == null && this.questionlist[this.questionIndex].productId != null) {
            this.questionIsProduct = true;
            new BaseService('Products').getById(this.questionlist[this.questionIndex].productId).then((response) => {
              // console.log(response.data);
              this.questionProductName = response.data.productName;
              this.questionProductId = response.data.id;
            }).catch((error) => {
              console.log(error)
            });

          }
          if (this.questionlist[this.questionIndex].confirmFormId != null && this.questionlist[this.questionIndex].productId == null) {
            this.questionIsProduct = false;
          }
          if (this.questionIndex === (this.questionlist.length - 1)) {
            this.btnName = "ذخیره";
          } else {
            this.btnName = "بعدی";
          }

        }
      },
      // let updateWork = {
      makeAnswer() {
        //   id: this.workId,
        // };
        // new BaseService('Works', '/ConfirmWorkState').update(updateWork).then((response) => {
        //   this.$noty.success("با تشکر، پاسخ با موفقیت ثبت شد");
        //   console.log(response.data);
        //
        // }).catch((error) => {
        //   console.log(error)
        // });
        // this.questionIndex++;
      },
      update() {
        // console.log("update");
        // this.tasksNotCompletedNew.map((task, index) => {
        //   task.order = index + 1;
        // });
        //
        // this.tasksCompletedNew.map((task, index) => {
        //   task.order = index + 1;
        // });
        //
        // let tasks = this.tasksNotCompletedNew.concat(this.tasksCompletedNew);
        //
        // axios.put('/demos/tasks/updateAll', {
        //   tasks: tasks
        // }).then((response) => {
        //   console.log(response.data);
        // }).catch((error) => {
        //   console.log(error);
        // })
      },
      getdamageType() {
        // this.isLoading = true;
        new BaseService('WorkProblems', '/GetdamageTypes').getList().then((response) => {
          // console.log(response.data);
          this.damageTypes = response.data;
          // this.isLoading = false;
        }).catch((error) => {
          // this.isLoading = false;
          console.log(error)
        })
      },
      openDamageModal() {
        console.log(this.$refs['setDamageState']);
        this.$refs['setDamageState'].show();
      },
      addDamage(work) {
        this.isLoading = true;
        console.log(work)
        let param = {
          productId: work.productId
        };
        new BaseService('Materials').getList(param).then((response) => {
          this.products = response.data.data;
          for (let i of this.products) {
            i.workId = work.id;
          }
          let mainProd = {
            id: null,
            materialName: work.productName,
            productId: work.productId,
            workId: work.id
          };
          this.products.push(mainProd);
          this.isLoading = false;
          setTimeout(() => {
            this.openDamageModal();
          }, 150);
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      damageTypeSelect(prop, data) {
        if (data !== null) {
          this.damageType = data;
          this.damageProduct.damageTypeId = data.id;
        }
      },
      productSelect(prop, data) {
        if (data !== null) {
          this.selectedProduct = data;
          this.damageProduct.workId = data.workId;
          if (data.id === null) {
            this.damageProduct.productId = data.productId;
            this.damageProduct.isMain = true;
          } else {

            this.damageProduct.productId = data.materialId;
          }
        }
        console.log(this.damageProduct)
      },
      damageOk() {

        if (this.damageProduct.productId === undefined || this.damageProduct.productId === 0) {
          this.$noty.error("لطفا محصول را انتخاب کنید");
        } else if (this.damageProduct.damageTypeId === undefined || this.damageProduct.damageTypeId === 0) {
          this.$noty.error("لطفا علت ضایعات شدن را انتخاب کنید");
        } else if (this.damageProduct.value === 0) {
          this.$noty.error("لطفا تعداد محصول را انتخاب کنید");
        } else {

          this.isLoading = true;
          // this.damageProduct.companyId = localStorage.getItem("companyId");
          new BaseService('WorkProblems/CreateDamageProducts').create(this.damageProduct).then((response) => {
            this.isLoading = false;
            this.$noty.success(response.data.value);
            this.getAllWorks();
          }).catch((error) => {
            this.getAllWorks();
            this.isLoading = false;
            this.$noty.error(error.data.value);
          });

        }
      },

      getUsers() {
        // this.isLoading = true;
        new BaseService('CompanyUserPost', '/GetCompanyUsers').getList().then((response) => {
          // console.log(response.data);
          this.users = response.data;
          if (this.users.length > 0) {
            for (const i of this.users) {
              i.name = i.user.firstName + " " + i.user.lastName;
            }
          }
          // this.isLoading = false;
        }).catch((error) => {
          // this.isLoading = false;
          console.log(error)
        })
      },
      userSelect(prop, data) {
        if (data !== null) {
          this.selectedUser = data.user;
          this.workReport.userId = data.user.id;
        }
      },

      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },

      setDateFromDatePicker(date) {
        console.log(date)
        if (this.dateClicked === 1) {
          this.startDate = date;
          this.workReport.start = date;
        }
        if (this.dateClicked === 2) {
          this.endDate = date;
          this.workReport.end = date;
        }

        // this.voucherModel.voucherDate = date;
      },
    }
  }
</script>

<style>
  .list {
    background-color: #26004d;
    border-radius: 3px;
    margin: 5px 5px;
    padding: 10px;
    width: 100%;
  }

  .list > header {
    font-weight: bold;
    color: white;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    cursor: grab;
  }

  .list article {
    border-radius: 3px;
    margin-top: 10px;
  }

  .list .card {
    background-color: #FFF;
    border-bottom: 1px solid #CCC;
    padding: 15px 10px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bolder;
  }

  .list .card:hover {
    background-color: #F0F0F0;
  }

  .drag-area {
    min-height: 10px;
  }
</style>
